import { render, staticRenderFns } from "./wltreeselect.vue?vue&type=template&id=595a45cb&"
import script from "./wltreeselect.vue?vue&type=script&lang=js&"
export * from "./wltreeselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports